import {IAdvanceFilter} from '../../shared/advanced-filters/components/advance-filter';
import {ContractControlAdvanceFilterParamType} from '../contract-control/advanced-filters';
import {CCAdvancedFilterBuilder} from '../contract-control/get-contract-control-request-builder';
import {IDashboardUpcomingEventsRequest} from './dashboard.service';

export class CcDashboardChartRequestBuilder  {
    private request: IDashboardUpcomingEventsRequest = {} as IDashboardUpcomingEventsRequest;
    private advanceFilterBuilder: CCAdvancedFilterBuilder = new CCAdvancedFilterBuilder();
    private readonly noCategoryId = -1;
    private readonly noCategoryValue = 'no_category';


    categories(categoryIds: number | number[] | string) {
        const normalized = Array.isArray(categoryIds) ? categoryIds[0] : categoryIds;
        const isNoCategory = normalized === this.noCategoryId || normalized === this.noCategoryValue;
        if (isNoCategory) {
            this.request.category_ids = this.noCategoryValue;
        } else if (categoryIds) {
            this.request.category_ids = categoryIds as number | number[];
        } else {
            delete this.request.category_ids;
        }

        return this;
    }

    documentType(id: number) {
        if (id != null) {
            this.request.document_type_id = id;
        } else {
            delete this.request.document_type_id;
        }

        return this;
    }


    status(status:string) {
        if(status!=null && status!='all'){
            this.request.status = status;
        }else{
            delete this.request.status
        }

        return this;
    }

    advancedFilters(filters:   IAdvanceFilter<ContractControlAdvanceFilterParamType>[]) {
        if (filters?.length > 0) {
            this.request.advanced = this.advanceFilterBuilder.build(filters);
        } else {
            delete this.request.advanced;
        }

        return this;
    }

    build(months: number): IDashboardUpcomingEventsRequest {
        return Object.keys(this.request).length > 0
            ? {
            ...this.request,
                'filter': months
            }
            : {
                'filter': months
            };
    }
}
 
